const interfaceConfig = {
  loginImage: '/images/lightbulb.jpg',
  signupImage: '/images/img_12.jpg',
  signupReasons: 'Join thousands of Bigs and Minis across all 50 states and 27 countries to share stories and form bonds.',
  orgName: 'Big & Mini',
};

export default interfaceConfig;
